<template>
    <div class="product-profile">
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="delete_product" title="Eliminar Producto">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <h4>El producto quedara en la papelera de reciclaje</h4>
                <button @click="deleteProduct()">Eliminar</button>
            </div>
        </b-modal>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="change_info" title="Cambiar Informacion">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <h4>Cambiar informacion</h4>
                <div>
                    <label for="">Nuevo Nombre</label>
                    <input type="text" v-model="new_name">
                </div>
                <div>
                    <label for="">Nueva categoria</label>
                    <b-select v-model="new_category">
                        <option v-for="(category, index) in category_list" :key="index" :value="category.name">{{category.name}}</option>
                    </b-select>
                </div>
                <div>
                    <label for="">Nuevo Precio</label>
                    <input type="number" v-model="new_price">
                </div>
                <button @click="changeInfo">Cambiar informacion</button>
            </div>
        </b-modal>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="inventory_modal" title="Añadir Inventario">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <h4>Ingresar pedido a inventario</h4>
                <div>
                    <label for="">Cantidad a ingresar</label>
                    <input type="number" v-model="inventory_cant">
                </div>
                <div>
                    <label for="">Precio de la factura</label>
                    <input type="number" v-model="inventory_price">
                </div>
                <div>
                    <label for="">N°de factura</label>
                    <input type="text" v-model="inventory_ref">
                </div>
                <div>
                    <label for="">Sede</label>
                    <select name="" id="" v-model="sede">
                        <option v-for="(sede, index) in sedes" :value="sede" :key="index">{{ sede }}</option>
                    </select>
                </div>
                <div>
                    <label for="">Detalles</label>
                    <textarea name="" id="" cols="30" rows="10" v-model="inventory_detalles"></textarea>
                </div>
                <button @click="addInventory">Ingresar Pedido</button>
            </div>
        </b-modal>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="delete_inventory" title="Añadir Inventario">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <h4>Eliminar unidades del producto</h4>
                <div>
                    <label for="">Cantidad</label>
                    <input type="number" v-model="inventory_suprim_cant">
                </div>
                <div>
                    <label for="">Detalles</label>
                    <textarea name="" id="" cols="30" rows="10" v-model="inventory_suprim_details"></textarea>
                </div>
                <button @click="deleteInventory">Eliminar</button>
            </div>
        </b-modal>
        <div>
            <div class="ingresos">
                <div>
                    <center>
                        <h3>Ultimos Ingresos</h3>
                        <table>
                            <thead>
                                <tr>
                                    <th>fecha</th>
                                    <th>Usuario</th>
                                    <th>Cantidad</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in inventory" :key="index">
                                    <td>{{item.fecha.split($store.state.constants.SEPARETOR)[0]}}</td>
                                    <td>{{item.usuario}}</td>
                                    <td>{{item.cantidad}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </center>
                </div>
            </div>
            <div class="ventas">
                <div>
                    <center>
                        <h3>Ultimas Ventas</h3>
                        <table>
                            <thead>
                                <tr>
                                    <th>fecha</th>
                                    <th>Comprador</th>
                                    <th>Vendedor</th>
                                    <th>Cantidad</th>
                                    <th>Valor</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(sell, index) in allSells" :key="index">
                                    <td>{{sell.fecha.split($store.state.constants.SEPARETOR)[0]}}</td>
                                    <td>{{sell.seller}}</td>
                                    <td>{{sell.buyer}}</td>
                                    <td>{{sell.cant}}</td>
                                    <td>{{sell.total}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </center>
                </div>
            </div>
        </div>
        <div>
            <div class="informacion">
                <div>
                    <div class="option">
                        <input type="radio" name="tienda" v-model="tienda" id="" value="mecato" v-on:change="changeProductType"><label for="">Mecato</label>
                        <input type="radio" name="tienda" v-model="tienda" id="" value="variedades" v-on:change="changeProductType"><label for="">Variedades</label>
                        <input type="radio" name="tienda" v-model="tienda" id="" value="jugueteria" v-on:change="changeProductType"><label for="">Jugueteria</label>
                    </div>
                    <center>
                        <h3>Informacion</h3>
                    </center>
                    <div class="general">
                        <label for="">Nombre: <span>{{name}}</span></label>
                        <label for="">Estado: <span>{{status}}</span></label>
                        <label for="">Categoria: <span>{{category}}</span></label>
                    </div>
                    <div class="other">
                        <div class="info">
                            <label for="">Ventas hoy: <span>{{ventasToday}}</span></label>
                            <label for="">Mejor comprador: <span>{{bestSell}}</span></label>
                            <label for="">Cantidad vendidos: <span>{{cantSells}}</span></label>
                        </div>
                        <div class="info">
                            <label for="">Stock: <span>{{stock}}</span></label>
                            <label for="">Precio: <span>{{price}}</span></label>
                        </div>
                        <div class="img"><img :src="img" alt=""></div>
                    </div>
                </div>
            </div>
            <div class="funciones">
                <input type="file" ref="select_file_product" name="photo" @change="productUpdatePhoto" class="register-file" accept="image/gif, image/jpeg, image/jpg, image/png, image/bmp" />
                <div>
                    <div>
                        <div><button @click="$refs.change_info.show()">Cambiar informacion</button></div>
                        <div><button @click="$refs.delete_product.show()">Eliminar producto</button></div>
                    </div>
                    <div>
                        <div><button @click="$refs.inventory_modal.show()">Ingresar a inventario</button></div>
                        <div><button @click="$refs.select_file_product.click()">Cambiar imagen</button></div>
                    </div>
                    <div>
                        <div><button @click="$refs.delete_inventory.show()">Dar de baja</button></div>
                        <!-- <div><button @click="$router.push('/solicitudes/productos')">Solicitudes</button></div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/api'
import { ToggleButton } from 'vue-js-toggle-button'
import Notify from '@/utils/Notification.js'

export default {
    name: 'product-profile',
    components: {
        ToggleButton
    },
    data() {
        return {
            ingresos: [],
            ventas: [],
            name: null,
            stock: null,
            price: null,
            status: null,
            category: null,
            ventasToday: null,
            bestSell: null,
            cantSells: null,
            img: null,
            tienda: null,
            inventory: [],
            category_list: [],
            new_category: null,
            new_name: null,
            new_price: null,
            allSells: [],
            inventory_cant: null,
            inventory_price: null,
            inventory_ref: null,
            inventory_detalles: null,
            productsPicture: null,
            productsPictureObject: null,
            inventory_suprim_cant: null,
            inventory_suprim_details: null,
            sedes: [],
            sede: null
        }
    },
    methods: {
        getSedes() {
            API.getSedesList()
                .then((res) => {
                    this.sedes = res
                })
        },
        changeProductType() {
            API.changeProductType(this.$route.params.product_name, this.tienda)
                .then((res) => {
                    this.getProductInfo()
                })
        },
        deleteProduct() {
            API.deleteProduct(this.$route.params.product_name)
                .then((res) => {
                    if (!res) {
                        throw Error(res)
                    }
                    this.$router.push('/productos')
                    Notify('dirty', 'Se ha eliminado el producto con exito')
                })
                .catch(() => {
                    Notify('error', 'El producto tiene ventas asociadas y no se puede eliminar. Pero ya no sera visible')
                    this.$router.push('/productos')
                })
        },
        deleteInventory() {
            API.deleteInventory({cant: this.inventory_suprim_cant, details: this.inventory_suprim_details}, this.$route.params.product_name)
                .then((res) => {
                    this.getProductInfo()
                    this.$refs.delete_inventory.hide()
                    Notify('dirty', 'Se ha restado ' + this.inventory_suprim_cant + 'al inventario el producto con exito')
                })
        },
        productUpdatePhoto (picture) {
            var file = picture.target.files || picture.dataTransfer.files
            if (!file.length) {
                return
            }

            this.saveImage(file[0], () => {
                API.productUpdatePhotoByName(this.productsPictureObject, this.$route.params.product_name)
                    .then(result => {
                        this.getProductInfo()
                        Notify('dirty', 'Se ha cambiado la imagen del producto')
                    })
                    .catch(error => {
                        console.log(error)
                    })
            })
        },
        saveImage (file, cb) {
            var reader = new FileReader()
            var vm = this
            reader.onload = (e) => {
                if (file.type === 'image/gif') {
                    vm.productsPicture = e.target.result
                    vm.productsPictureObject = file
                    if (cb) {
                        var toSend = {}
                        toSend.src = vm.productsPicture
                        cb(toSend)
                    }
                } else {
                    var image = new Image()
                    image.src = e.target.result
                    var width = 0
                    var height = 0
                    image.onload = function() {
                        width = this.width
                        height = this.height
                        var canvas = document.createElement('canvas')
                        var ctx = canvas.getContext('2d')
                        ctx.drawImage(image, 0, 0)
                        var maxWidth = 400
                        var maxHeight = 400
                        if (width > height) {
                            if (width > maxWidth) {
                                height *= maxWidth / width
                                width = maxWidth
                            }
                        } else {
                            if (height > maxHeight) {
                                width *= maxHeight / height
                                height = maxHeight
                            }
                        }
                        canvas.width = width
                        canvas.height = height
                        ctx = canvas.getContext('2d')
                        ctx.drawImage(image, 0, 0, width, height)
                        vm.productsPicture = canvas.toDataURL(file.type)
                        var byteString
                        if (vm.productsPicture.split(',')[0].indexOf('base64') >= 0) {
                            byteString = atob(vm.productsPicture.split(',')[1])
                        } else {
                            byteString = unescape(vm.productsPicture.split(',')[1])
                        }
                        var mimeString = vm.productsPicture.split(',')[0].split(':')[1].split(';')[0]
                        var ia = new Uint8Array(byteString.length)
                        for (var i = 0; i < byteString.length; i++) {
                            ia[i] = byteString.charCodeAt(i)
                        }
                        try {
                            vm.productsPictureObject = new File([new Blob([ia], {type: mimeString})], file.type)
                        } catch (err) {
                            vm.productsPictureObject = new Blob([ia], {type: mimeString})
                            vm.productsPictureObject.name = file.name
                            vm.productsPictureObject.lastModifiedDate = new Date()
                        }

                        if (cb) {
                            cb(image)
                        }
                    }
                }
            }
            reader.readAsDataURL(file)
        },
        changeInfo() {
            if (this.new_category === null) {
                return
            }
            if (this.new_name === null) {
                return
            }
            if (this.new_price === null) {
                return
            }
            API.changeProductInfo({name: this.new_name, category: this.new_category, price: this.new_price}, this.$route.params.product_name)
                .then((res) => {
                    this.$router.push('/productos/' + this.new_name + '/profile')
                    this.getProductInfo()
                    this.$refs.change_info.hide()
                    Notify('dirty', 'Se actualizo la informacion del producto')
                })
        },
        addInventory() {
            var info = {
                cantidad: this.inventory_cant,
                detalles: this.inventory_detalles,
                price: this.inventory_price,
                ref: this.inventory_ref,
                sede: this.sede
            }
            API.addInventory(info, this.$route.params.product_name)
                .then(res => {
                    this.getIngresos()
                    this.getProductInfo()
                    this.$refs.inventory_modal.hide()
                })
        },
        getProductInfo() {
            API.getProductInfo(this.$route.params.product_name)
                .then((res) => {
                    this.name = res.name
                    this.stock = res.stock
                    this.price = res.precio
                    if (res.status === 'available') {
                        this.status = 'Disponible'
                    } else if (res.status === 'block') {
                        this.status = 'Eliminado'
                    } else {
                        this.status = 'No disponible'
                    }
                    this.category = res.category
                    this.ventasToday = res.sellstoday
                    this.bestSell = res.bestSeller
                    this.cantSells = res.cantidad
                    this.img = res.img
                    this.new_category = this.category
                    this.tienda = res.type
                })
        },
        getIngresos() {
            API.getIngresos(this.$route.params.product_name)
                .then((res) => {
                    this.inventory = res
                })
        },
        getSells() {
            API.getSells(this.$route.params.product_name)
                .then((res) => {
                    this.allSells = res
                })
        },
        getCategoryList() {
            API.getCategoryList()
                .then((res) => {
                    this.category_list = res
                })
        }
    },
    mounted() {
        this.getProductInfo()
        this.getIngresos()
        this.getSells()
        this.getCategoryList()
        this.getSedes()
    }
}
</script>

<style scoped>
    h3 {
        color: #fff;
        border-bottom-style: groove;
        padding: 10px;
    }
    table {
        margin-top: 20px;
        height: 100%;
    }
    table > thead > tr > th {
        color: #fff;
        padding: 25px;
        border-style: solid;
    }
    table > tbody > tr > td {
        color: #fff;
        padding-left: 25px;
        padding-right: 25px;
        padding-top: 5px;
        padding-bottom: 5px;
        border-style: solid;
    }
    .product-profile{
        background-color: #cdcdcd;
        height: 90vh;
        padding: 10px;
    }
    .product-profile > div {
        display: flex;
        width: 100%;
        height: 50%;
    }
    .product-profile > div > .ingresos {
        padding: 20px;
        width: 70%;
        height: 100%;
    }
    .product-profile > div > .ingresos > div{
        background-color: #63b763;
        height: 100%;
        border-radius: 15px;
        padding: 20px;
    }

    .product-profile > div > .ventas {
        padding: 20px;
        width: 100%;
        height: 100%;
    }
    .product-profile > div > .ventas > div{
        background-color: #8363b7;
        height: 100%;
        border-radius: 15px;
        padding: 20px;
    }
    .product-profile > div > .ventas > div > center {
        overflow-y: auto;
        height: 100%;
    }
    .product-profile > div > .informacion {
        padding: 20px;
        width: 180%;
        height: 100%;
        position: relative;
    }
    .product-profile > div > .informacion > div > .option {
        position: absolute;
    }
    .product-profile > div > .informacion > div > .option > input {
        margin: 20px;
    }
    .product-profile > div > .informacion > div > .div-toggle > label {
        font-weight: bold;
    }
    .product-profile > div > .informacion > div{
        background-color: #63b1b7;
        height: 100%;
        border-radius: 15px;
        padding: 20px;
    }
    .product-profile > div > .informacion > div > .general {
        width: 100%;
        padding: 10px;
        height: 15%;
    }
    .product-profile > div > .informacion > div > .general > label{
        width: 30%;
        color: #fff;
        font-weight: bold;
        float: left;
        position: relative;
        border-right-style: groove;
        margin-right: 20px;
    }
    .product-profile > div > .informacion > div > .general > label > span{
        color: #000;
        right: 7%;
        position: absolute;
    }
    .product-profile > div > .informacion > div > .other {
        width: 100%;
        padding: 10px;
        display: flex;
        height: 70%;
        border-top-style: groove;
    }
    .product-profile > div > .informacion > div > .other > div {
        width: 50%;
    }
    .product-profile > div > .informacion > div > .other > .info {
        color: #fff;
        font-weight: bold;
        display: grid;
        border-right-style: groove;
        margin-right: 10px;
        width: 40%;
        padding: 20px;
    }
    .product-profile > div > .informacion > div > .other > .info > label {
        position: relative;
    }
    .product-profile > div > .informacion > div > .other > .info > label > span {
        color: #000;
        position: absolute;
        right: 5%;
    }
    .product-profile > div > .informacion > div > .other > .img {
        position: relative;
        width: 30%;
    }
    .product-profile > div > .informacion > div > .other > .img > img{
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: 10px;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .product-profile > div > .funciones {
        padding: 20px;
        width: 70%;
        height: 100%;
    }
    .product-profile > div > .funciones > div{
        background-color: #b78863;
        height: 100%;
        border-radius: 15px;
        padding: 20px;
        width: 100%;
    }
    .product-profile > div > .funciones > div > div{
        display: flex;
        width: 100%;
        height: 33.333333%;
    }
    .product-profile > div > .funciones > div > div > div{
        width: 50%;
        position: relative;
    }
    .product-profile > div > .funciones > div > div > div > button{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: #e0b059;
        color: #fff;
        width: 150px;
        height: 60px;
        border-radius: 30px;
    }
    .info-wrapper > div {
        padding: 20px;
        width: 400px;
        display: grid;
    }
    .info-wrapper > div > label {
        font-weight: bold;
        margin-right: 5px;
    }
    .info-wrapper > div > input {
        width: 100%;
        height: 35px;
        border-radius: 15px;
        text-align: center;
    }
    .info-wrapper > button {
        background-color: #e0b059;
        color: #fff;
        width: 150px;
        height: 60px;
        border-radius: 30px;
    }
    input[type=file] {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Tienda/ProductProfile.vue